export default "__VITE_ASSET__3dc62aea__"